import OrderInformationPage from "./OrderInformationPage";

export default OrderInformationPage;
